"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataService = void 0;
const price_1 = require("./utils/price");
const multi_transaction_1 = require("multi-transaction");
const near_1 = require("./near");
class DataService {
    pyth;
    coingecko;
    near;
    solana;
    ethereum;
    constructor({ pyth, coingecko, near, solana, ethereum }) {
        this.pyth = pyth;
        this.coingecko = coingecko;
        this.near = near;
        this.solana = solana;
        this.ethereum = ethereum;
    }
    async getPriceInUsd(tokenIdOrSymbol) {
        const priceFeedId = this.pyth.priceFeedIds[tokenIdOrSymbol];
        if (!priceFeedId) {
            throw Error(`Price feed id for token id or symbol '${tokenIdOrSymbol}' not configured`);
        }
        try {
            return await (0, price_1.getPriceInUsdFromPyth)(this.pyth.apiUrl, priceFeedId);
        }
        catch (e) {
            console.warn(`Failed to getPriceInUsdFromPyth, fallback to CoinGecko: ${e}`);
            const id = this.coingecko.ids[tokenIdOrSymbol];
            if (!id) {
                throw Error(`Coingecko token ID for token '${tokenIdOrSymbol}' not configured`);
            }
            return (0, price_1.getPriceFromCoinGecko)(this.coingecko.apiUrl, id);
        }
    }
    async getLinearPriceInUsd(tokenId) {
        if (!this.near) {
            throw Error('`near` not configured');
        }
        const linearPriceInNear = await (0, near_1.getLinearPriceInNear)(this.near.viewer, tokenId);
        const nearPriceInUsd = await this.getPriceInUsd('NEAR');
        return nearPriceInUsd.multipliedBy(multi_transaction_1.Units.format(linearPriceInNear, 24));
    }
    async getStnearPriceInUsd(tokenId) {
        if (!this.near) {
            throw Error('`near` not configured');
        }
        const stnearPriceInNear = await (0, near_1.getStnearPriceInNear)(this.near.viewer, tokenId);
        const nearPriceInUsd = await this.getPriceInUsd('NEAR');
        return nearPriceInUsd.multipliedBy(multi_transaction_1.Units.format(stnearPriceInNear, 24));
    }
    async getPtTokenPriceInUsd(ptTokenSymbol, ptTokenDecimals) {
        if (!this.ethereum) {
            throw Error('`ethereum` not configured');
        }
        const { marketAddress, underlyingTokenAddress } = this.ethereum.pendle.ptTokenInfos[ptTokenSymbol];
        const underlyingTokenPriceInUsd = await this.getPriceInUsd(underlyingTokenAddress);
        const ptTokenPriceInUnderlyingToken = await (0, price_1.getPtToSyRate)(this.ethereum.client, this.ethereum.pendle.oracleAddress, marketAddress);
        return underlyingTokenPriceInUsd.multipliedBy(multi_transaction_1.Units.format(ptTokenPriceInUnderlyingToken.toString(), ptTokenDecimals));
    }
}
exports.DataService = DataService;
//# sourceMappingURL=data-service.js.map